import React from 'react';

const UserContext = ({ userInfo, teamsLoading, teamsError }) => {
  return (
    <div className="user-context-section">
      <h2 className="section-title">User Context</h2>
      <div className="user-info-grid">
        <div className="user-info-item">
          <span className="label">Tenant Id:</span>
          <span className={`value ${teamsLoading ? 'loading' : ''}`}>
            {teamsError ? 'Error loading' : userInfo.tenantId}
          </span>
        </div>
        <div className="user-info-item">
          <span className="label">Email:</span>
          <span className={`value ${teamsLoading ? 'loading' : ''}`}>
            {teamsError ? 'Error loading' : userInfo.userPrincipalName}
          </span>
        </div>
      </div>
      {teamsError && (
        <div className="error" style={{ display: 'block' }}>
          {teamsError}
        </div>
      )}
    </div>
  );
};

export default UserContext;
